var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border-radius":"20px","overflow":"hidden"}},[_c('div',{ref:"toolbar",attrs:{"id":_vm.toolbarId}}),_c('div',{style:(`height: ${_vm.height}px`),attrs:{"id":_vm.editorId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }